import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewActualizaCaravana = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'actualiza_caravana',
        name: 'Actualiza Caravana',
        component: ViewActualizaCaravana,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
